
const hex_alphas = Array.from({length: 101}).map( (x, index) => {
  const percent = index * 0.01;
  const final = Math.round(255 * percent);
  return final.toString(16).padStart(2, '0').toUpperCase()
} );

//-----------------------------------------------------------------
export function getHexAlpha(percent) {
  //-----------------------------------------------------------------
  return hex_alphas[percent];
}